import ProductLanguageSelectContainer from "./productLanguageSelect.container";

export default ProductLanguageSelectContainer;
